<template>
  <div>
    <label class="text-xs font-medium text-gray-600" v-if="label">
      {{ label }}
      <span v-if="required" class="text-red-700">*</span>
    </label>
    <v-date-input
      v-model="internalValue"
      :placeholder="placeholder"
      :variant="variant"
      :density="density"
      :hide-details="hideDetails"
      :color="color"
      :rules="rules"
      :bg-color="bgColor"
      :prepend-icon="prependIcon"
      :prepend-inner-icon="prependInnerIcon"
      :disabled="disabled"
      :multiple="multiple"
      :clearable="clearable"
      :min="min"
      :max="max"
      @update:modelValue="onUpdate"
    />
  </div>
</template>

<script>
import {
  pushFormatOverride,
  popFormatOverride,
  setFormatOverrideAtIndex,
} from "@/plugins/vuetify";

export default {
  name: "FormDate",
  props: {
    label: { type: String, required: false },
    placeholder: { type: String, default: "" },
    modelValue: { type: [Object, Array, null], default: null },
    required: { type: Boolean, default: false },
    variant: { type: String, default: "outlined" },
    density: { type: String, default: "compact" },
    hideDetails: { type: String, default: "auto" },
    color: { type: String, default: "#475569" },
    bgColor: { type: String },
    prependIcon: { type: String, default: null },
    prependInnerIcon: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    multiple: { type: String },
    clearable: { type: String },
    rules: { type: Array, default: () => [] },
    /** Tanggal minimum yang bisa dipilih (string ISO atau Date) */
    min: { type: [String, Date], default: undefined },
    /** Tanggal maksimum yang bisa dipilih (string ISO atau Date) */
    max: { type: [String, Date], default: undefined },
    /** Format tampilan tanggal (DD/MM/YYYY, DD-MM-YYYY, dll) */
    formatString: { type: String, default: "DD/MM/YYYY" },
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  watch: {
    formatString(val) {
      if (this._formatOverrideIndex != null) {
        setFormatOverrideAtIndex(this._formatOverrideIndex, val);
      }
    },
  },
  created() {
    this._formatOverrideIndex = pushFormatOverride(this.formatString);
  },
  beforeUnmount() {
    popFormatOverride();
    this._formatOverrideIndex = undefined;
  },
  methods: {
    onUpdate(val) {
      if (val === null) {
        this.$emit("clear");
      } else {
        this.$emit("change", val);
      }
    },
  },
  emits: ["update:modelValue", "change"],
};
</script>
